import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.707 14.293l-1.414 1.414L12 10.414l-5.293 5.293-1.414-1.414L12 7.586l6.707 6.707z" }));
export default createSvgIcon(iconPath, "ArrowStrokeUp");
//# sourceMappingURL=ArrowStrokeUpIcon.js.map